import React, { createContext, useState, useContext, useEffect } from 'react';
import { fetchAllLocation, getProcessedStorageToStorage } from './LocationUtils.js';

// Create the context
const GeneralnfoContext = createContext();

// Custom hook to use the LocationContext
export const useGeneralInfo = () => useContext(GeneralnfoContext);

// Provider component
export const GeneralInfoProvider = ({ children }) => {
    const getDeviceType = () => {
        const width = window.innerWidth;
        if (width <= 600) return 0;
        if (width <= 768) return 1;
        if (width <= 1024) return 2;
        if (width <= 1440) return 3;
        return 4;
    };
    const [locationData, setLocationData] = useState([]);
    const userLocationCode = JSON.parse(localStorage.getItem("user"))?.LocationCode ?? '';
    const [selectedLocation, setSelectedLocation] = useState();
    // the following two states are used to do the return function.
    const [targetReturn, setTargetReturn] = useState(false);
    const [returnFunction, setReturnFunction] = useState(false);
    // detect what the devices is used. 0 => phone, 1=> ipad, 2=> computer.
    const [devices, setDevices] = useState(getDeviceType());

    useEffect(() => {
        fetchAllLocation(setLocationData);
        if (!selectedLocation) {
            setSelectedLocation(getProcessedStorageToStorage(localStorage.getItem("selectedLocation"), userLocationCode))
        }
        const handleResize = () => setDevices(getDeviceType());
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        // Only set if selectedLocation is not undefined
        if (selectedLocation) {
            if (getProcessedStorageToStorage(selectedLocation) === '') {
                // Swal.fire("The selected location is not in database. Switch back to the user location. ")
                // console.log(userLocationCode);
                setSelectedLocation(userLocationCode);
                localStorage.setItem("selectedLocation", userLocationCode);
            } else {
                setSelectedLocation(getProcessedStorageToStorage(selectedLocation));
                localStorage.setItem("selectedLocation", selectedLocation);
            }
        }
    }, [selectedLocation]);

    return (
        <GeneralnfoContext.Provider
            value={{ locationData, setLocationData, selectedLocation, setSelectedLocation, targetReturn, setTargetReturn, returnFunction, setReturnFunction, devices }}
        >
            {children}
        </GeneralnfoContext.Provider>
    );
};